export default __webpack_public_path__ + "locales/pt-BR/JavascriptSdk.json?hash=9ac9555528b68d0f1ed7c0036284d4ac";